import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { categoriaDoAnexo, nomeCurto, podeAbrirNoNavegador, rotuloDoAnexo, tamanhoLegivel, } from '@mymaxx/shared';
import { useState } from 'react';
import { baixarMidia } from './baixar-midia.js';
import { PreviaDoArquivo } from './PreviaDoArquivo.js';
export function CartaoDeArquivo({ url, nomeOriginal, mimeType, tamanho, previaUrl, perguntarOndeSalvar, }) {
    const [baixando, setBaixando] = useState(false);
    const [erro, setErro] = useState(false);
    const categoria = categoriaDoAnexo(mimeType, nomeOriginal);
    const podeAbrir = podeAbrirNoNavegador(mimeType, nomeOriginal);
    const baixar = async () => {
        setBaixando(true);
        setErro(false);
        const deu = await baixarMidia(url, nomeOriginal, { perguntarOnde: perguntarOndeSalvar });
        setBaixando(false);
        if (!deu)
            setErro(true);
    };
    return (_jsxs("div", { className: "mb-1 w-64 max-w-full overflow-hidden rounded-lg bg-black/10 dark:bg-white/10", children: [_jsx(PreviaDoArquivo, { url: url, mimeType: mimeType, nomeOriginal: nomeOriginal, previaUrl: previaUrl }), _jsxs("div", { className: "flex items-center gap-2 px-2 py-1.5", children: [_jsx(IconeDoArquivo, { categoria: categoria }), _jsxs("div", { className: "min-w-0 flex-1", children: [_jsx("p", { className: "truncate text-xs font-medium", title: nomeOriginal, children: nomeCurto(nomeOriginal) }), _jsxs("p", { className: "text-[11px] opacity-70", children: [rotuloDoAnexo(mimeType, nomeOriginal), tamanho ? ` · ${tamanhoLegivel(tamanho)}` : ''] })] })] }), _jsxs("div", { className: "flex border-t border-black/10 text-[11px] dark:border-white/10", children: [podeAbrir && (_jsx("a", { href: url, target: "_blank", rel: "noreferrer", className: "flex-1 border-r border-black/10 py-1.5 text-center font-medium hover:bg-black/5 dark:border-white/10 dark:hover:bg-white/5", children: "Abrir" })), _jsx("button", { type: "button", onClick: () => void baixar(), disabled: baixando, className: "flex-1 py-1.5 text-center font-medium hover:bg-black/5 disabled:opacity-60 dark:hover:bg-white/5", children: baixando ? 'Baixando…' : erro ? 'Tentar de novo' : 'Baixar' })] })] }));
}
/**
 * O ícone do tipo, desenhado à mão.
 *
 * `@mymaxx/ui` não depende de biblioteca de ícones de propósito, e não vale puxar uma
 * inteira por meia dúzia de traços.
 */
function IconeDoArquivo({ categoria }) {
    const comum = {
        width: 22,
        height: 22,
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 1.8,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        'aria-hidden': true,
        className: 'shrink-0 opacity-70',
    };
    if (categoria === 'planilha') {
        return (_jsxs("svg", { ...comum, children: [_jsx("rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }), _jsx("path", { d: "M3 9h18M3 15h18M9 3v18M15 3v18" })] }));
    }
    if (categoria === 'mapa') {
        return (_jsxs("svg", { ...comum, children: [_jsx("path", { d: "M9 3 3 6v15l6-3 6 3 6-3V3l-6 3-6-3Z" }), _jsx("path", { d: "M9 3v15M15 6v15" })] }));
    }
    if (categoria === 'compactado') {
        return (_jsxs("svg", { ...comum, children: [_jsx("rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }), _jsx("path", { d: "M11 3v3M13 6v3M11 9v3M13 12v3M11 15v2h2v-2" })] }));
    }
    if (categoria === 'apresentacao') {
        return (_jsxs("svg", { ...comum, children: [_jsx("rect", { x: "3", y: "4", width: "18", height: "12", rx: "2" }), _jsx("path", { d: "M12 16v4M8 20h8" })] }));
    }
    // PDF, documento e o que sobrar: a folha com o canto dobrado.
    return (_jsxs("svg", { ...comum, children: [_jsx("path", { d: "M14 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7l-5-5Z" }), _jsx("path", { d: "M14 2v5h5" })] }));
}
//# sourceMappingURL=CartaoDeArquivo.js.map